<template>
  <div class="bottom-tips">
    <img
      class="bottom-tips-logo"
      src="@/assets/images/bottom-logo.png"
      alt="logo"
    />
    <div class="bottom-tips-text">技术支持：广州日报社 全媒体技术研发部</div>
  </div>
</template>

<script setup lang="ts"></script>
<style lang="scss" scoped>
.bottom-tips {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 76px;
  margin-top: 30px;
  background: #fff;
  opacity: 0.7;

  .bottom-tips-logo {
    width: 120px;
  }

  .bottom-tips-text {
    margin-top: 5px;
    font-size: 0.75rem;
    color: var(--bottom-tips-color);
  }
}
</style>
